import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Home = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.4192 3.60687L4.41702 9.60773C4.30591 9.70162 4.21662 9.81861 4.15539 9.95057C4.09417 10.0825 4.06247 10.2262 4.0625 10.3717V19.3719C4.0625 19.6372 4.16786 19.8915 4.35539 20.0791C4.54293 20.2666 4.79728 20.3719 5.0625 20.3719H8.0625V14.3719C8.0625 13.8415 8.27321 13.3328 8.64829 12.9577C9.02336 12.5827 9.53207 12.3719 10.0625 12.3719H14.0625C14.5929 12.3719 15.1016 12.5827 15.4767 12.9577C15.8518 13.3328 16.0625 13.8415 16.0625 14.3719V20.3719H19.0625C19.3277 20.3719 19.5821 20.2666 19.7696 20.0791C19.9571 19.8915 20.0625 19.6372 20.0625 19.3719V10.3719C20.0625 10.2265 20.0308 10.0825 19.9696 9.95057C19.9084 9.81861 19.8191 9.7016 19.708 9.60771L19.7028 9.60327L12.708 3.60871C12.7073 3.60809 12.7065 3.60748 12.7058 3.60687C12.5257 3.45549 12.2979 3.37247 12.0625 3.37247C11.8271 3.37247 11.5993 3.45549 11.4192 3.60687ZM10.126 2.08119C10.6675 1.62355 11.3535 1.37247 12.0625 1.37247C12.7715 1.37247 13.4575 1.62355 13.999 2.08119L14.0042 2.08562L20.999 8.08019C20.9999 8.08099 21.0009 8.08179 21.0018 8.08259C21.3338 8.36388 21.6007 8.71403 21.7838 9.10876C21.9675 9.50455 22.0626 9.93563 22.0625 10.3719C22.0625 10.3719 22.0625 10.372 22.0625 10.3719V19.3719C22.0625 20.1676 21.7464 20.9307 21.1838 21.4933C20.6212 22.0559 19.8582 22.3719 19.0625 22.3719H15.0625C14.5102 22.3719 14.0625 21.9242 14.0625 21.3719V14.3719H10.0625V21.3719C10.0625 21.9242 9.61478 22.3719 9.0625 22.3719H5.0625C4.26685 22.3719 3.50379 22.0559 2.94118 21.4933C2.37857 20.9307 2.0625 20.1676 2.0625 19.3719V10.3722C2.0625 10.3721 2.0625 10.3723 2.0625 10.3722C2.06243 9.93587 2.15753 9.50455 2.34118 9.10876C2.52433 8.71406 2.79114 8.36393 3.12309 8.08265L10.126 2.08119Z'
        fill={primaryColorToUse}
      />
    </svg>
  );
};
